module.exports = __webpack_public_path__ + "static/media/report-black-icon.b00d3682.svg";